exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cookie-consent[data-v-9fbe0414]{position:fixed;bottom:0;left:0;right:0;background-color:#1e3a5f;color:#fff;padding:20px;font-size:12px;z-index:1000;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.cookie-consent p[data-v-9fbe0414]{margin:0;-ms-flex:1;flex:1;text-align:left}.cookie-consent a[data-v-9fbe0414]{color:#fff;text-decoration:underline}.cookie-consent button[data-v-9fbe0414]{background-color:#42bc97;border:none;color:#fff;padding:10px 20px;text-align:center;text-decoration:none;display:inline-block;font-size:15px;margin-left:20px;cursor:pointer;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9fbe0414","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/CookieConsent.vue
// module id = 857
// module chunks = 0